/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';

import { JobListFilterDto, JobRestService, JobSpecRestService } from '@gh/builder-shared-data';
import { getRouteQueryParam, InitViewService } from '@gh/common-shared';
import { SlicedDataSource } from '@gh/core-data';
import { GridLayoutService } from '@gh/core-ui-grid';

import { JobListItem } from './job.model';
import { FilterNames, FilterRestService } from '@gh/builder-shared';

@Injectable()
export class JobSpecListBusinessService implements InitViewService {
  constructor(private jobRest: JobRestService,
              private jobSpecRest: JobSpecRestService,
              private filterService: FilterRestService,
              private gridLayoutService: GridLayoutService) {

  }

  initView(route: ActivatedRouteSnapshot): any {
    return {
      gridLayout: this.gridLayoutService.get('jobSpecList'),
      filter: this.filterService.get(FilterNames.jobSpecList),
      createSpec: getRouteQueryParam(route, 'createSpec'),
      message: getRouteQueryParam(route, 'message'),
    };
  }

  findAllAsDataSource(filter: JobListFilterDto): SlicedDataSource<JobListItem> {
    return this.jobSpecRest.findAllAsDataSource(filter);
  }
}
